import React from 'react';
import ReactDOM from 'react-dom/client';
import Rutas from './route/Rutas';
import './i18n'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Rutas />
  </React.StrictMode>
);


// reportWebVitals();
